import styles from './EnterHighlight.module.css'

/**
 * The product's signature element (brief: "the language of co-presence"). One short flash on a card,
 * row or comment that appeared or moved because of the other person — or an MCP agent.
 *
 * ONE pass, never a loop, never for our own changes. Mount inside a positioned container.
 */
export function EnterHighlight({ active }: { active: boolean }): React.JSX.Element | null {
  if (!active) return null
  return <span className={styles.flash} aria-hidden="true" />
}
